import { render, staticRenderFns } from "./TabLayout.vue?vue&type=template&id=92fb4756&scoped=true"
import script from "./TabLayout.vue?vue&type=script&lang=js"
export * from "./TabLayout.vue?vue&type=script&lang=js"
import style0 from "./TabLayout.vue?vue&type=style&index=0&id=92fb4756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fb4756",
  null
  
)

export default component.exports